import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ContactGroup } from '@app/core/interfaces/c5/contact-group';
import { PhoneBookContact } from '@app/core/interfaces/c5/phone-book-contact';
import { UpdateContactGroupComponent } from '@app/shared/components/update-contact-group/update-contact-group.component';
import { DialogService } from '@app/shared/dialog/dialog.service';
import { NumberMap } from '@app/utils/number-map';
import { ContactsMode } from '../contacts/contacts.mode';

@Component({
  selector: 'portal-contact-groups',
  templateUrl: './contact-groups.component.html',
  styles: [],
  standalone: false,
})
export class ContactGroupsComponent implements OnInit {
  @Input()
  mode!: ContactsMode;

  @Input()
  contactGroups: ContactGroup[];

  @Input()
  contacts: PhoneBookContact[];

  @Input()
  header?: TemplateRef<any>;

  @Input()
  loading: boolean;

  @Input()
  reload: () => void;

  @Input()
  remove: (contactGroup: Partial<ContactGroup>) => Promise<any>;

  @Input()
  title: string = 'phoneBook.contact.groups';

  @Input()
  update: (contactGroup: ContactGroup | Partial<ContactGroup>) => Promise<any>;

  canAddOrDelete: boolean = false;

  contactsMode = ContactsMode;

  /**
   * Contains the IDs of the contact group that is currently being deleted
   */
  public removing: NumberMap<ContactGroup> = {};

  public triggerAdd = () => {
    this.dialogService.open(UpdateContactGroupComponent).withInput({
      mode: this.mode,
      contacts: this.contacts,
      update: this.update,
    });
  };

  public refresh = () => {
    this.reload();
  };

  constructor(private dialogService: DialogService) {}

  ngOnInit() {
    if (this.mode !== this.contactsMode.CALL_CENTER_AGENT) {
      this.canAddOrDelete = true;
    }
  }

  isFavorite(contactGroup: ContactGroup) {
    return contactGroup.name === '';
  }

  triggerEdit(contactGroup: ContactGroup) {
    this.dialogService
      .open(UpdateContactGroupComponent, {
        size: this.canAddOrDelete ? undefined : 'sm',
      })
      .withInput({
        mode: this.mode,
        contactGroup,
        contacts: this.contacts,
        update: this.update,
      });
  }

  triggerRemove(contactGroup: ContactGroup) {
    this.dialogService.openRemovalConfirmationDialog(() => {
      this.removing[contactGroup.id] = contactGroup;

      return this.remove(contactGroup).finally(() => {
        delete this.removing[contactGroup.id];
      });
    });
  }
}
